import Reveal from "../components/Reveal";

interface Post { cat: string; title: string; author: string; date: string; href: string; }
const POSTS: Post[] = [
  { cat: "AI Strategy",   title: "Why AI-native beats AI-bolted-on in industrial software",                                     author: "Paisums Editorial", date: "6 min read", href: "/blog/posts/ai-native-vs-bolt-on.html" },
  { cat: "Defence-Ready", title: "The seven gaps we find in every defence-readiness audit, and how to close them in 30 days",  author: "Defence Practice",  date: "8 min read", href: "/blog/posts/defence-readiness-audit-gaps.html" },
  { cat: "Mining",        title: "From telematics to copilots: predictive maintenance for Pilbara fleets",                      author: "Industry · Mining", date: "5 min read", href: "/blog/posts/pilbara-predictive-maintenance.html" },
];

const GRADIENTS = [
  "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.18), transparent 55%), repeating-linear-gradient(45deg, rgba(255,255,255,0.04) 0 10px, transparent 10px 20px), #0c1018",
  "radial-gradient(circle at 70% 70%, rgba(255,255,255,0.18), transparent 55%), repeating-linear-gradient(-45deg, rgba(255,255,255,0.04) 0 10px, transparent 10px 20px), #0c1018",
  "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.16), transparent 60%), repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0 10px, transparent 10px 20px), #0c1018",
];

export default function Insights() {
  return (
    <section id="insights" className="bg-black py-28 md:py-40 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="flex items-end justify-between gap-6 flex-wrap mb-12 md:mb-16">
            <div>
              <div className="text-white/40 text-sm tracking-widest uppercase">Insights</div>
              <h2 className="font-instrument text-5xl md:text-7xl text-white tracking-tight mt-4 leading-[1.05]">
                Field notes from the <em className="italic-serif text-white/50">AI revolution</em>
              </h2>
            </div>
            <a href="/blog.html" className="text-white/80 hover:text-white text-sm">All articles →</a>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {POSTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 120}>
              <a href={p.href} className="block h-full">
                <article className="liquid-glass rounded-3xl overflow-hidden h-full flex flex-col group hover:bg-white/[0.02] transition-colors cursor-pointer">
                  <div className="aspect-[16/10] relative overflow-hidden">
                    <div className="absolute inset-0" style={{ background: GRADIENTS[i % GRADIENTS.length] }} />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  </div>
                  <div className="p-6 md:p-7 flex flex-col flex-1">
                    <div className="text-white/40 text-xs tracking-widest uppercase">{p.cat}</div>
                    <h4 className="font-instrument text-white text-xl md:text-2xl tracking-tight mt-3 leading-[1.2]">{p.title}</h4>
                    <div className="mt-auto pt-6 flex items-center justify-between text-white/40 text-xs tracking-widest uppercase">
                      <span>{p.author}</span>
                      <span>{p.date}</span>
                    </div>
                  </div>
                </article>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
